
import React from 'react'
import {  popularCategories, popularProjects } from './mock';
import { PopularItem } from './popularItem';

export const Popularity = () => {
    require('slick-carousel/slick/slick.css')
    require('slick-carousel/slick/slick-theme.css')

    return (
        <React.Fragment>
           <PopularItem items={popularCategories} title="Popular Category"  />
           <PopularItem items={popularProjects} title="Popular Projects" user />
        </React.Fragment>
    )
}
